import React, { useEffect, useState } from 'react';

interface FeedbackBtnProps {
    sessionKey: string;
    good?: boolean;
    onClick: () => Promise<void>;
}

const FeedbackBtn: React.FC<FeedbackBtnProps> = ({
    sessionKey,
    good,
    onClick
}) => {
    const [isDisabled, setIsDisabled] = useState<boolean>(() => {
        return sessionStorage.getItem(sessionKey) !== null;
    });

    useEffect(() => {
        const handleFeedbackGiven = (event: CustomEvent) => {
            const { sessionKey: feedbackSessionKey } = event.detail;
            // Toggles the button state based on whether feedback has been given for this session key
            setIsDisabled(feedbackSessionKey === sessionKey);
        };

        window.addEventListener(
            'feedbackGiven',
            handleFeedbackGiven as EventListener
        );

        return () => {
            window.removeEventListener(
                'feedbackGiven',
                handleFeedbackGiven as EventListener
            );
        };
    }, [sessionKey]);

    const handleOnClick = async () => {
        if (!isDisabled) {
            await onClick();
        }
    };

    return (
        <button
            className='btn btn-outline-primary btn-feedback'
            onClick={handleOnClick}
            disabled={isDisabled}
        >
            {good ? '👍' : '👎'}
        </button>
    );
};

export default FeedbackBtn;
